export const recognizedCampaignUnitHeadings = ['campaignunit', 'kampanjeenhet'];
export const recognizedSalesPriceHeadings = ['salesprice', 'salgspris'];
export const recognizedSecondaryDiscountPercentage = [
  'secondarydiscount',
  'sekundaerrabatt',
  'secondarydiscountpercentage',
];
export const recognizedTertiaryDiscountPercentage = [
  'tertiarydiscount',
  'tertierrabatt',
  'tertiarydiscountpercentage',
];
export const recognizedImposedSalesPriceHeadings = [
  'imposedsalesprice',
  'pålagtsalgspris',
  'obligatorisktförsäljningspris',
];
export const recognizedPurchasePriceHeadings = [
  'purchaseprice',
  'innkjøpspris',
  'innkjopspris',
  'köppris',
];
